export default __webpack_public_path__ + "static/media/work-flow.b68481ff.png";